<template>
    <div class="lb-timeline">
        <div class="lb-timeline-background has-background-dark is-overlay" />
        <div class="timeline-wrapper">
            <div class="timeline-content-day">
                <div class="timeline-line" />
                <div
                    v-for="item in items"
                    :key="item._id"
                    :data-tooltip="item.title"
                    class="timeline-content-item has-tooltip-left"
                    @click="$emit('click', { _id: item._id })"
                >
                    <span></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            hoveredIndex: null,
        };
    },
    computed: {},
};
</script>

<style scoped lang="scss">
.lb-timeline {
    top: 0;
    bottom: 0;
    right: 0;
    width: 5rem;
    position: absolute;
}
.lb-timeline-background {
    height: 100%;
    opacity: 0.4;
}
.timeline-wrapper {
    height: 100%;
    width: 5rem;
    position: relative;
    color: #fff;
    text-align: center;

    .timeline-line {
        display: block;
        height: 94%;
        width: 1px;
        background: white;
        position: absolute;
        left: 50%;
        -webkit-box-shadow: 0 0 1px black;
        -moz-box-shadow: 0 0 1px black;
        box-shadow: 0 0 1px black;
        top: 3%;
        bottom: 3%;
        margin-top: 2.5px;
    }

    .timeline-content-day {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .timeline-content-item {
        display: flex;
        background: url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7);
        width: 100%;
        position: relative;
        height: 6%;
        -webkit-transition: width 0.5s;
        -moz-transition: width 0.5s;
        -o-transition: width 0.5s;
        transition: width 0.5s;
        z-index: 1;

        > span {
            height: 2rem;
            display: block;
            font-weight: bold;
            position: absolute;
            top: 50%;
            margin-top: -0.25em;
            width: 100%;
            text-shadow: 0 0 2px black;
            cursor: pointer;

            &:before {
                content: ' ';
                display: block;
                width: 0.5em;
                height: 0.5em;
                background: white;
                margin: 0 auto 0.5em auto;
                -moz-border-radius: 50%;
                -webkit-border-radius: 50%;
                border-radius: 50%;
                -webkit-box-shadow: 0 0 1px black;
                -moz-box-shadow: 0 0 1px black;
                box-shadow: 0 0 1px black;
            }
        }
    }
}
[data-tooltip].has-tooltip-left::before {
    left: 2rem;
}
[data-tooltip].has-tooltip-left::after {
    left: calc(2rem-11px);
}
</style>
